import { useNavigate } from 'react-router';
import { useOrganization } from '~/hooks/useOrganization';
import { Button } from './ui/button';
import { LogOutIcon } from 'lucide-react';
import classNames from 'classnames';
import { authClient } from '../services/auth-client';
import { useCheckInAdmin } from '../hooks/useCheckInAdmin';

interface Params {
  alwaysShowText?: boolean;
  className?: string;
}

export function ButtonLogout({ alwaysShowText = false, className }: Params) {
  const navigate = useNavigate();
  const { orgSlug, hasCustomDomain } = useOrganization();
  const { data: session } = authClient.useSession();
  const isInAdmin = useCheckInAdmin();

  if (!session) {
    return null;
  }

  const handleLogout = async () => {
    await authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          if (isInAdmin && orgSlug) {
            navigate(`/admin/${orgSlug}/login`);
            return;
          }

          navigate(!hasCustomDomain && orgSlug ? `/${orgSlug}` : '/');
        },
      },
    });
  };

  return (
    <Button
      className={classNames('gap-2', className)}
      size="sm"
      onClick={handleLogout}
    >
      <span className={alwaysShowText ? '' : 'hidden md:block'}>Logout</span>
      <LogOutIcon className="h-4 w-4" />
    </Button>
  );
}
